import CityManagementPage from "./shared/CityManagementPage";
import { cityConfigs } from "./shared/cityConfig";

export default function Leeds() {
  return <CityManagementPage config={cityConfigs.leeds} />;
}